export var CalendarView;
(function (CalendarView) {
    CalendarView["MONTH"] = "MONTH";
    CalendarView["WEEK"] = "WEEK";
    CalendarView["DAY"] = "DAY";
    CalendarView["THREE_DAY"] = "THREE_DAY";
    CalendarView["CUSTOM_RANGE"] = "CUSTOM_RANGE";
})(CalendarView || (CalendarView = {}));
//# sourceMappingURL=calendar-view.enum.js.map